<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:90%;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">消息通知 - {{companyInfo.COMPANY_NAME}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0.9rem 1.1rem 5rem;">
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
          <div style="position: relative;">
            <div style="position: absolute;left:-0.25rem;top:0;width:4.5rem;height:4.5rem;">
              <v-img v-if="deviceInfo.DEV_ICON != ''" :src="$iconPath + '/' + deviceInfo.DEV_ICON + '.png' " />
              <v-img v-else src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1331027771,2731791486&fm=26&gp=0.jpg"></v-img>
            </div>
            <v-row>
              <v-col :cols="3"  style="color:#9e9e9e;padding-right:0">
                  <!-- 进程状态 -->
              </v-col>
              <v-col :cols="9" style="padding-bottom:0.6rem;">
                <span v-if="!activated">未激活</span>
                <span v-else-if="deviceInfo.CUR_SID === '2'" style="color:#67C23A">正常</span>
                <span v-else style="color:#F56C6C">异常</span>
                <span v-if="activated" style="padding-left:0.5rem;padding-right:0.3rem;font-size:0.75rem;">( {{$moment(deviceInfo.ACTION_TIME).from()}}</span>
                <span v-if="activated" style="font-size:0.75rem;">{{$moment(deviceInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}} )</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                <!-- 设备名称 -->
              </v-col>
              <v-col :cols="9" style="padding-top:0px;">
                {{deviceInfo.DEV_TEXT}}
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  进程名称
              </v-col>
              <v-col :cols="9">
                  {{propInfo.PR_FILENAME}}
                  <span v-if="!activated" style="color:#ddd;">
                    未指定名称
                  </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  CPU占用率
              </v-col>
              <v-col :cols="9">
                  {{propInfo.PR_CPU}} %
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  内存使用量
              </v-col>
              <v-col :cols="9">
                  {{$util.formatByteText(propInfo.PR_MEMORY)}}
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  内存占用率
              </v-col>
              <v-col :cols="9">
                  {{propInfo.PR_MEMORY_PERCENT}} %
              </v-col>
            </v-row>
          </div>
          <div v-if="showMoreProp">
            <!-- <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">
                ID
              </v-col>
              <v-col :cols="9">
                {{propInfo.IOT_ID}}
              </v-col>
            </v-row> -->
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">
                  进程ID
              </v-col>
              <v-col :cols="9">
                  {{propInfo.PR_PROCESS_ID}}
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">
                  检查间隔
              </v-col>
              <v-col :cols="9">
                  {{propInfo.PR_SPAN_TIME_S}} 秒
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">
                  活跃时间
              </v-col>
              <v-col :cols="9" v-if="activated">
                  <span>{{$moment(deviceInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}}</span>
              </v-col>
            </v-row>
          </div>
          <div style="color:#9e9e9e;font-size:0.8rem;text-align:center;margin-top:0.5rem;">
            <span @click="showMoreProp=!showMoreProp">
              <span>查看更多</span>
              <i class="fa fa-angle-down" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-if="!showMoreProp"></i>
              <i class="fa fa-angle-up" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-else></i>
            </span>
          </div>
          <div>
            <v-divider style="margin:1.2rem 0;" />
            <div>
              <div style="padding-bottom:0.3rem;font-size:0.97rem;">警报信息</div>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;">警报描述</v-col>
                <v-col :cols="9" v-if="activated">
                    <span>{{alertInfo.ALERT_CONTENT}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;">开始时间</v-col>
                <v-col :cols="9" v-if="activated">
                    <span>{{$moment(alertInfo.ALERT_START_DATE).format("YYYY-MM-DD HH:mm:ss")}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;">持续时间</v-col>
                <v-col :cols="9" v-if="activated">
                    <span>{{getTimeStr(alertInfo.ALERT_DURATION)}}</span>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
export default {
  components: { LoadingText },
  props: {
  },
  data() {
    return {
      iotId: '',
      propInfo: {},
      deviceInfo: {},
      showMoreProp: false,
      companyInfo: {},
      activated: false,
      loading: true,
      alertId: 0,
      alertInfo: {}
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.alertId = that.$route.params.id
    await that.getDeviceAlert()
    await that.getDevice()
    await that.getDevProp()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async getDevProp() {
      var that = this
      await that.$api.iot.getProcessProp({ iot_id: that.iotId }).then(res => {
        // console.log('getProcessProp.res', res);
        if (!res.success) {
          // that.$toast.error('获取属性失败')
          console.log('获取设备属性失败', res);
          return
        }
        that.propInfo = res.data
      })
    },
    async getDevice() {
      var that = this
      await that.$api.iot.getDevice({ iot_id: that.iotId }).then(res => {
        // console.log('getDevice.res', res);
        if (!res.success) {
          // that.$toast.error('获取设备信息失败')
          console.log('获取设备信息失败', res);
          return
        }
        var data = res.data
        that.deviceInfo = data.device
        that.companyInfo = data.company
        that.activated = that.deviceInfo.CUR_SID !== '0'
      })
    },
    async getDeviceAlert() {
      var that = this
      await that.$api.bz.getDeviceAlert({ alert_id: that.alertId }).then(res => {
        // console.log('getDeviceAlert.res', res);
        if (!res.success) {
          // that.$toast.error('获取设备信息失败')
          console.log('获取设备警报信息失败', res);
          return
        }
        that.alertInfo = res.data
        that.iotId = that.alertInfo.DEVICE_IOT_ID
      })
    },
    getTimeStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    }
  }
}
</script>

<style scoped>
</style>
